import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=f03246e2&scoped=true"
import script from "./Free.vue?vue&type=script&lang=js"
export * from "./Free.vue?vue&type=script&lang=js"
import style0 from "./Free.vue?vue&type=style&index=0&id=f03246e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03246e2",
  null
  
)

export default component.exports